import { Expose, Type } from 'class-transformer';
import { EventCategoryModel } from '../models/event-category.model';

export class GetCategoryResponseDto extends EventCategoryModel {
  @Expose({ name: 'code' })
  code: string;
  @Expose({ name: 'is_active' })
  isActive: boolean;
  @Expose({ name: 'icon' })
  icon: string;
  @Expose({ name: 'sub_category' })
  subCategory: any;
}
